import { render, staticRenderFns } from "./financialManagement.vue?vue&type=template&id=4db136e6&scoped=true"
import script from "./financialManagement.vue?vue&type=script&lang=js"
export * from "./financialManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db136e6",
  null
  
)

export default component.exports